var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[(_vm.loading)?_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("登录中...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }